// function getTextFromTags(tags) {
//   const regex = /(<([^>]+)>)/ig; // 匹配html标签的正则表达式
//   const textArr = []; // 存储纯文本的数组

//   tags.forEach((tag) => {
//     const text = tag.innerHTML.replace(regex, ''); // 去除html标签
//     textArr.push(text.trim()); // 去除空格并加入数组
//   });

//   return textArr;
// }

function removeTagsAndLineBreaks(str) {
  // 去除 HTML 标签
  str = str.replace(/<\/?[^>]+>/gi, '');
  // 去除换行和回车
  str = str.replace(/[\r\n]/g, '');
  return str;
}
function anchor(content) {
    let content1 = content.replace(/<\/?[^>]+>/gi, '');
    let content2 = content1.replace(/[\r\n]/g, '');
    return content2
}
export default {
    anchor
}
